import { AllowedFilters } from "../types/List";

export type AllowedParam =
  | AllowedFilters
  | "parent_id"
  | "doc_id"
  | "first_name"
  | "id"
  | "invited"
  | "offer"
  | "page"
  | "planned"
  | "redirect_to"
  | "token"
  | "pending_offer_uuid";

function currentHref(): string {
  if (typeof window !== "undefined" && window.location) {
    return window.location.href;
  }
  if (typeof global !== "undefined" && (global as any).location) {
    return (global as any).location.href;
  }
  return "";
}

export default function getParamFromUrl(
  param: AllowedParam,
  url: string = currentHref(),
): string {
  if (!url) {
    return "";
  }
  return new URL(url).searchParams.get(param) || "";
}

export function getUrlParam(param: string): string | null {
  return new URL((global as any).location.href).searchParams.get(param);
}
